import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridTabContacte = _resolveComponent("GridTabContacte")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "red-underline" }, "CONTACTE", -1)),
      _createVNode(_component_GridTabContacte, { onSelectionChanged: _ctx.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
    ]),
    _: 1
  }))
}